/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DiscordRelayMessageHistoryMessages,
    DiscordRelayMessageHistoryMessagesFromJSON,
    DiscordRelayMessageHistoryMessagesFromJSONTyped,
    DiscordRelayMessageHistoryMessagesToJSON,
} from './';

/**
 * 
 * @export
 * @interface InlineObject9
 */
export interface InlineObject9 {
    /**
     * Socket ID of the client to send history to
     * @type {string}
     * @memberof InlineObject9
     */
    socketId: string;
    /**
     * Discord channel ID
     * @type {string}
     * @memberof InlineObject9
     */
    channelId: string;
    /**
     * Array of historical messages
     * @type {Array<DiscordRelayMessageHistoryMessages>}
     * @memberof InlineObject9
     */
    messages: Array<DiscordRelayMessageHistoryMessages>;
    /**
     * Bot authentication token
     * @type {string}
     * @memberof InlineObject9
     */
    botToken: string;
}

export function InlineObject9FromJSON(json: any): InlineObject9 {
    return InlineObject9FromJSONTyped(json, false);
}

export function InlineObject9FromJSONTyped(json: any, ignoreDiscriminator: boolean): InlineObject9 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'socketId': json['socketId'],
        'channelId': json['channelId'],
        'messages': ((json['messages'] as Array<any>).map(DiscordRelayMessageHistoryMessagesFromJSON)),
        'botToken': json['botToken'],
    };
}

export function InlineObject9ToJSON(value?: InlineObject9 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'socketId': value.socketId,
        'channelId': value.channelId,
        'messages': ((value.messages as Array<any>).map(DiscordRelayMessageHistoryMessagesToJSON)),
        'botToken': value.botToken,
    };
}


